import client from "../client";

/* ==========================================================
   ORG USERS  (users that belong to a specific organization)
   Endpoint base: /users/allOrgUsers
========================================================== */
export const listOrgUsers = async (orgId) => {
  const query = orgId ? `?orgId=${orgId}` : "";
  const res = await client.get(`/users/allOrgUsers${query}`);
  return res.data;
};

/* ==========================================================
   SYSTEM USERS  (super-admin created users, orgId = null)
   Endpoint base: /users/allSystemUsers  &  /users
   Matches dashboard-api.postman_collection.json → "Users"
========================================================== */

/**
 * GET /users/allSystemUsers
 * Server-side list with pagination + role filter + search + sort.
 * @param {Object} params
 * @param {number} params.page   1-based page number
 * @param {number} params.limit  page size
 * @param {string} params.role   "all" | "Super Admin" | "Moderator" | "Auditor"
 * @param {string} params.search free-text search
 * @param {string} params.sortBy e.g. "name"
 */
export const listSystemUsers = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    role = "all",
    search = "",
    sortBy = "",
  } = params;

  const qs = new URLSearchParams();
  qs.set("page", page);
  qs.set("limit", limit);
  qs.set("role", role || "all");
  if (search) qs.set("search", search);
  if (sortBy) qs.set("sortBy", sortBy);

  const res = await client.get(`/users/allSystemUsers?${qs.toString()}`);
  return res.data;
};

/**
 * POST /users/create
 * For a super-admin user orgId must be null.
 * payload: { name, email, department, initialRole, orgId, permissions }
 */
export const createSystemUser = async (payload) => {
  const res = await client.post("/users/create", payload);
  return res.data;
};

/**
 * PATCH /users/:userId
 * Partial update — send only the keys you want to change:
 *  - basic info : { name, department, initialRole }
 *  - permissions: { permissions: {...} }
 *  - disable    : { isDisabled: true|false }
 *  - role       : { initialRole: "Moderator" }
 */
export const updateSystemUser = async (userId, data) => {
  const res = await client.patch(`/users/${userId}`, data);
  return res.data;
};

/** DELETE /users/:userId */
export const deleteSystemUser = async (userId) => {
  const res = await client.delete(`/users/${userId}`);
  return res.data;
};

export const createOrgUser = async (payload) => {
  const res = await client.post("/users/create", payload);
  return res.data;
};

export const updateOrgUser = async (userId, data) => {
  const res = await client.patch(`/users/${userId}`, data);
  return res.data;
};

export const deleteOrgUser = async (userId) => {
  const res = await client.delete(`/users/${userId}`);
  return res.data;
};
